export default "__VITE_ASSET__BP$7zb7L__"